import AIChatPage from './AIChatPage'

export default AIChatPage